<template>
  <div class="pump6ColumnTable_ctn" :style="style" :class="{ size2, isLongLanguage }">
    <div v-for="(row, i) in list" :key="`insulindeliverysettingtable_row${i}_${id}`" class="pump6ColumnTable_descriptionRow" :class="{ 'pump6ColumnTable_descriptionRow': true, 'pump6ColumnTable_titleRow--top': +i === 0, 'roundedCorner-t-l': +i === 0, 'roundedCorner-t-r': +i === 0, 'roundedCorner-b-l': +i === (rowNums - 1), 'roundedCorner-b-r': +i === (rowNums - 1) }">
      <template v-for="j in 3">
        <div :key="`insulindeliverysettingtable_row${i}_${id}_col${j - 1}_0`" :class="{ 'pump6ColumnTable_descriptionRow--label': true, 'roundedCorner-t-l': +i === 0, 'roundedCorner-b-l': +i === (rowNums - 1) }">
          {{ row[j - 1] ? row[j - 1]['column0'] : '' }}
        </div>
        <div :key="`insulindeliverysettingtable_row${i}_${id}_col${j - 1}_1`" :class="{ 'pump6ColumnTable_descriptionRow--content': true }">
          {{ row[j - 1] ? row[j - 1]['column1'] : '' }}
        </div>
      </template>
      <!-- <div :class="{ 'pump6ColumnTable_descriptionRow--label': true, 'roundedCorner-t-l': +i === 0, 'roundedCorner-b-l': +i === (rowNums - 1) }"> -->
      <!--   {{ list[v - 1] ? list[v - 1]['column0'] : '' }} -->
      <!-- </div> -->
      <!-- <div :class="{ 'pump6ColumnTable_descriptionRow--content': true }"> -->
      <!--   {{ list[v - 1] && list[v - 1]['column1'] ? `${list[v - 1]['column1']}` : '' }}{{ list[v - 1] && list[v - 1]['column1'] ? 'U/h' : ''}} -->
      <!-- </div> -->
      <!-- <div :class="{ 'pump6ColumnTable_descriptionRow--label': true }"> -->
      <!--   {{ list[v - 1] ? list[v - 1]['column2'] : '' }} -->
      <!-- </div> -->
      <!-- <div :class="{ 'pump6ColumnTable_descriptionRow--content': true }"> -->
      <!--   {{ list[v - 1] && list[v - 1]['column3'] ? `${list[v - 1]['column3']}` : '' }}{{ list[v - 1] && list[v - 1]['column3'] ? 'U/h' : ''}} -->
      <!-- </div> -->
      <!-- <div :class="{ 'pump6ColumnTable_descriptionRow--label': true }"> -->
      <!--   {{ list[v - 1] ? list[v - 1]['column4'] : '' }} -->
      <!-- </div> -->
      <!-- <div :class="{ 'pump6ColumnTable_descriptionRow--content': true, 'roundedCorner-t-r': +i === 0, 'roundedCorner-b-r': +i === (rowNums - 1) }"> -->
      <!--   {{ list[v - 1] && list[v - 1]['column5'] ? `${list[v - 1]['column5']}` : '' }}{{ list[v - 1] && list[v - 1]['column5'] ? 'U/h' : ''}} -->
      <!-- </div> -->
    </div>
  </div>
</template>
<script>
import reDrawTrigger from '@mx/reDrawTrigger'
import dayjs from 'dayjs'
import { derrorFactory, errorFactory } from '@u/log'
import { _getMergedPumpBigDosageFromRecords } from '@u/reportHelper'
const derror = derrorFactory('InsulinDeliverySettingTable.vue', true)
const error = errorFactory('InsulinDeliverySettingTable.vue', true)

let _id = 1
export default {
  name: 'CInsulinDeliverySettingTable',
  components: {
  },
  mixins: [reDrawTrigger],
  props: {
    width: {
      type: [String, Number],
      default: 455
    },
    size2: {
      type: [Number, Boolean, String],
      default: false
    },
    list: {
      type: [Array],
      default: () => []
    },
    rowNums: {
      type: [Number],
      default: 10
    },
    showMarginRight: {
      type: [Number, Boolean, String],
      default: true
    },
    showHeader: {
      type: [Number, Boolean, String],
      default: false
    }
  },
  data() {
    _id++
    const id = `pump2columnstable_${+new Date()}_${_id}`
    
    return {
      id
    }
  },
  computed: {
    style() {
      const { showMarginRight, zoomRatio, width } = this
      const rst = { zoom: zoomRatio, width: `${width}px` }
      
      if (`${showMarginRight}`.toLowerCase().trim() !== `false` && showMarginRight) {
        rst.marginRight = Math.floor(zoomRatio * 20) + 'px'
      }
      return rst
    }
  },
  mounted() {
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      const i = `${rowIndex}`
      if (i === '0') {
        return 'first-row'
      } else if (i === '11') {
        return 'last-row'
      }
      return ''
    },
    tableCellClassName({ row = {}, column = {}}) {
      const { isSum = false } = row
      const { property = '' } = column
      const ps = `${property}`
      if (ps === 'cell11') {
        return 'corner_cell--bright'
      }
      return ''
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/mixin';
@import '@/styles/variables';

.pump6ColumnTable_ctn {
    color: $colorGluMesurementFont;
    font-weight: 600;
    font-size: $sizeFontSize;
    display: inline-block;
    @include bBox;
    .pump6ColumnTable_titleRow {
        @include bBox;
        height: $rowH;
        /* @include heightMiddle($rowH); */
        @include flexRow(flex-start, center);
        .highLowTable-titleRow_content {
            @include bBox;
            width: 50%;
            flex-shrink: 1;
            text-align: center;
        }
    }
    .pump6ColumnTable_border--right {
        border-right: 1px solid $colorGluMesurementInnerBorder;
    }
    .pump6ColumnTable_titleRow, .pump6ColumnTable_descriptionRow {
        @include bBox;
        /* @include heightMiddle($rowH); */
        height: $rowH;
        overflow: hidden;
        /* min-height: $rowH; */
        border: 1px solid $colorGluMesurementInnerBorder;
        border-top-width: 0;
        /* border-bottom-width: 0; */
        text-indent: 7px;
        &.pump6ColumnTable_titleRow--last {
            border-bottom: 1px solid $colorGluMesurementInnerBorder;
        }
        &.pump6ColumnTable_titleRow--top {
            /* text-indent: 20px; */
            border-top-width: 1px;
            /* border-bottom-width: 1px; */
        }
    }
    .pump6ColumnTable_descriptionRow {
        @include flexRow;
        .pump6ColumnTable_descriptionRow--label, .pump6ColumnTable_descriptionRow--content {
            @include bBox;
            flex-grow: 1;
            flex-shrink: 1;
            text-align: center;
            height: 100%;
            min-height: $rowH;
            width: 15%;
            @include flexColumn(center, center)
        }
        .pump6ColumnTable_descriptionRow--content {
            font-weight: normal;
        }
        .pump6ColumnTable_descriptionRow--label {
            background-color: $colorGluMesurementLabelBg;
            color: $colorGluMesurementFont;
            padding: 0 5px;
            text-indent: 0;
            
            &.pump6ColumnTable_descriptionRow--label2 {
                width: 25%;
                flex-grow: 0;
                font-size: 0.92em;
            }
            &.pump6ColumnTable_descriptionRow--label3 {
                width: calc(263 / 455) * 100%;
                flex-grow: 0;
                font-size: 1em;
            }
        }
    }
    
    &.size2 {        
        .pump6ColumnTable_titleRow, .pump6ColumnTable_descriptionRow {
            @include bBox;
            height: $rowH2;
        }
        .pump6ColumnTable_descriptionRow {
            .pump6ColumnTable_descriptionRow--label, .pump6ColumnTable_descriptionRow--content {
                min-height: $rowH;
            }
        }
    }

    &.isLongLanguage {
        .pump6ColumnTable_descriptionRow {
            .pump6ColumnTable_descriptionRow--label {
                width: 16%;
                flex-grow: 3;
                flex-shrink: 1;
            }
            .pump6ColumnTable_descriptionRow--content {
                width: 10%;
                flex-grow: 1;
                flex-shrink: 1;
            }
        }
    }
}
</style>
